import { useUserStore } from "../store";
const useRole = () => {
  const roles = useUserStore((state) => state?.user?.roles);
  const isAdmin = roles?.includes("ROLE_ADMIN");
  return { isAdmin };
};

export default useRole;
